import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {push} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {FormattedMessage} from 'react-intl';
import * as actionCreators from '../actions';
import AppBar from 'material-ui/AppBar';
import {List, ListItem} from 'material-ui/List';
import {Card, CardHeader, CardText, CardActions} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import Avatar from 'material-ui/Avatar';
import Paper from 'material-ui/Paper';
import FileFolder from 'material-ui/svg-icons/file/folder';
import RightTopMenu from '../components/RightTopMenu';
import CenteredSpinner from '../components/CenteredSpinner';
import ButtonSpinner from '../components/ButtonSpinner';

class HomeView extends Component {
   constructor(props) {
      super(props);

      this.state = {
         clickedBtnKey: 'none'
      };

      this.handleLinkClick = this.handleLinkClick.bind(this);
   }

   handleLinkClick(bookKey, e) {
      const {token, currentBookKey, currentArticleKey, listLeafKeyToIndexMap, actions, dispatch} = this.props;

      this.setState({clickedBtnKey:bookKey});

      if (bookKey !== currentBookKey){
         actions.fetchBookData(token, bookKey);
      } else {
         const firstArticleKey = Object.keys(listLeafKeyToIndexMap)[0];
         if (firstArticleKey === currentArticleKey) {
            const path = `/book/${currentBookKey}/article/${currentArticleKey}`;
            dispatch(push(path));
         }else{
            actions.setCurrentArticleKey(firstArticleKey);
         }
      }
   }

   componentWillMount() {
      const {isBooksDataFetching, booksData} = this.props;

      this.setState({clickedBtnKey:'none'});

      if (!isBooksDataFetching && !booksData){
         this.fetchData();
      }
   }

   componentWillReceiveProps(nextProps){
      const {currentBookKey, currentArticleKey, dispatch} = this.props;
      if (!!nextProps.currentBookKey && !!nextProps.currentArticleKey && (nextProps.currentBookKey !== currentBookKey || nextProps.currentArticleKey !== currentArticleKey)){
         let path = `/book/${nextProps.currentBookKey}/article/${nextProps.currentArticleKey}`;
         dispatch(push(path));
      }
   }

   fetchData() {
      const {token, actions} = this.props;
      actions.fetchBooksData(token);
   }

   render() {
      const {isBooksDataFetching, booksData, isBookDataFetching} = this.props;
      const paperStyle = {
         margin: 16,
         marginBottom: 0,
         padding: 20,
         maxWidth: 1140,
         textAlign: 'center',
         fontSize: 16,
         color: 'rgb(0, 188, 212)',
         display: 'inline-block',
         boxShadow: 'none'
      };
      return (
         <div>
            <AppBar
               title={<span><FormattedMessage id="homeView.appBar.title" defaultMessage="Аprentis Docs" /></span>}
               iconElementLeft={<span />}
               iconElementRight={<RightTopMenu/>}
            />
            <div>
               {isBooksDataFetching === true || !booksData
                  ? <CenteredSpinner />
                  :
                  <div>
                     <div className="cards-wrapper" style={{textAlign:'center'}}>
                        <Paper style={paperStyle} zDepth={1}>
                           <span style={{fontSize:18,color:'rgb(0, 164, 185)'}}>
                              <FormattedMessage id="homeView.paper.desc1" defaultMessage="Here you'll find all the information you need to start using the Aprentis platform at once" />
                           </span><br/>
                           <span style={{fontSize:19,color:'rgb(3, 177, 199)'}}>
                              <FormattedMessage id="homeView.paper.desc2" defaultMessage="Learn how to create, customize and deliver your first application without programming skills" />
                           </span><br/>
                           <span style={{fontSize:20}}>
                              <FormattedMessage id="homeView.paper.desc3" defaultMessage="Follow short and simple instructions to customize the default CRM application for your business needs" />
                           </span>
                        </Paper>
                     </div>
                     <List className="cards-wrapper row">
                        {booksData.list.map(item =>
                           <ListItem key={item.key} className="item col-sm-6 col-md-6 col-lg-6">
                              <Card style={{backgroundColor:'#f7f7f7'}}>
                                 <CardHeader
                                    titleStyle={{fontSize:22,marginTop:10,lineHeight:'22px',textShadow:'0 1px 0 #fff',color:'rgb(0, 188, 212)',cursor:'text'}}
                                    title={item.fields.custom_book}
                                    actAsExpander={false}
                                    showExpandableButton={true}
                                    avatar={<Avatar icon={<FileFolder />} backgroundColor="rgb(0, 188, 212)" />}
                                    style={{cursor:'default'}}
                                 />
                                 <CardText expandable={true}>
                                    <Paper style={{padding:20}} zDepth={1}>
                                       <div dangerouslySetInnerHTML={{__html: item.fields.custom_article}}></div>
                                    </Paper>
                                 </CardText>
                                 <CardActions style={{textAlign:'center',cursor:'default'}}>
                                    {isBookDataFetching && this.state.clickedBtnKey === `${item.key}` ?
                                       <ButtonSpinner/> :
                                       <div style={{margin:0}}>
                                          <div className="CrawlerLink">
                                             <a key={item.key} href={`/book/${item.key}/article/${item.key}`}>{item.fields.custom_book}</a>
                                          </div>
                                          <FlatButton style={{margin:0}}
                                                      labelStyle={{fontSize:16,color:'rgb(224, 77, 130)'}}
                                                      label={<FormattedMessage id="homeView.card.btnLabel" defaultMessage="Read book..." />}
                                                      onTouchTap={(e) => this.handleLinkClick(item.key, e)} />
                                       </div>
                                    }
                                 </CardActions>
                              </Card>
                           </ListItem>
                        )}
                     </List>
                  </div>
               }
            </div>
         </div>
      );
   }
}

HomeView.propTypes = {
   actions: PropTypes.object.isRequired,
   isBooksDataFetching: PropTypes.bool,
   booksData: PropTypes.object,
   isBookDataFetching: PropTypes.bool,
   currentBookKey: PropTypes.string,
   currentArticleKey: PropTypes.string,
   listLeafKeyToIndexMap: PropTypes.object
};

const mapStateToProps = (state) => ({
   booksData: state.data.booksData,
   isBooksDataFetching: state.data.isBooksDataFetching,
   currentBookKey: state.data.currentBookKey,
   currentArticleKey: state.data.currentArticleKey,
   isBookDataFetching: state.data.isBookDataFetching,
   listLeafKeyToIndexMap: state.data.listLeafKeyToIndexMap
});

const mapDispatchToProps = (dispatch) => ({
   actions: bindActionCreators(actionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeView);


// WEBPACK FOOTER //
// ./src/views/HomeView.js